<template>
  <div :class="col">
    <div :class="[type]" role="alert" :style="{marginBottom: marginBottom}">
      <b v-if="header">{{header}}&nbsp;</b>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'w-alert',
  props: {
    col: {
      type: String,
      default: 'col-lg-12'
    },
    header: {
      type: String,
      default: 'Uwaga!'
    },
    marginbottom: {
      type: String,
      default: '20px'
    },
    alertType: {
      type: String,
      default: 'warning'
    }
  },
  data() {
    return {};
  },
  computed: {
    type() {
      return this.alertType.startsWith('alert-') ? this.alertType : 'alert-' + this.alertType;
    }
  }
};
</script>

<style>
</style>